import { jsx as t } from "react/jsx-runtime";
import l from "clsx";
import { s as a } from "../../../form-item.module-avu57bh1.js";
const b = ({
  id: m,
  htmlFor: r,
  children: o,
  className: e,
  ...s
}) => /* @__PURE__ */ t(
  "label",
  {
    id: m,
    htmlFor: r,
    className: l(a["form-item__label"], e),
    ...s,
    children: o
  }
);
export {
  b as FormItemLabel
};
